import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import DataAPI from '../api/DataApi';

function Header() {
    

    return (
        <>
        <div className='App-container'>
              <div className="maincontainer">
                  <header className='hidden lg:flex page-header'>
                      <div className='page-header-company-data'>
                          <p style={{margin: '0px', padding: 10, display: 'flex', alignItems: 'center'}}>
                              <i className="material-icons-outlined md-18">mail</i>
                              &nbsp;servicios@racolcomputers.com
                          </p>
                          <p style={{margin: '0px', padding: 10, display: 'flex', alignItems: 'center'}}>
                              <i className="material-icons-outlined md-18">phone</i>
                              &nbsp;(809)-971-3157
                          </p>
                          <p style={{margin: '0px', padding: 10, display: 'flex', alignItems: 'center'}}>
                              <i className="material-icons-outlined md-18">location_on</i>
                              &nbsp;Av. 27 de Febrero No.37, Santiago de los Caballeros
                          </p>
                      </div>
                      <div className='page-header-social-media'>
                          <i style={{ marginLeft: 15}} className='fab fa-facebook'></i>
                          <i style={{ marginLeft: 15}} className='fab fa-linkedin'></i>
                      </div>
                  </header>
              </div>
          </div>
          <div className='App-CompanyLogo-container sticky top-0 z-50'>
              <div className='maincontainer flex flex-row md:grid md:grid-cols-10 items-center px-4'>
                    <div className='w-1/2 md:w-auto'>
                        <a className='' href="/"><img src="./assets/img/logoSistema2.png" alt="company logo" /></a>
                    </div>
                  <div className='text-standardGray font-bold ml-12 col-span-7 hidden md:block'>
                      <ul className='flex flex-row space-x-8 text-lg list-none'>
                          <li><a className='text-standardGray header-link' href="/">Home</a></li>
                          <li><a className='text-standardGray header-link' href="http://localhost:3000/#services">Servicios</a></li>
                          {/* <li>Productos</li> */}
                          <li><a className='text-standardGray header-link' href="http://localhost:3000/#contact">Contacto</a></li>
                      </ul>
                  </div>
                  <div className='w-1/2 justify-end text-end items-center md:w-auto md:col-span-2 '>
                    <Link to={'/login'}>
                        <Button style={{ fontWeight: 'bold' }} onClick={()=> {window.scrollTo({top: 0, left: 0, behavior: 'smooth'});}} className='web-boton'>
                            <i className="material-icons-outlined md-18">person</i>&nbsp;<span className='hidden md:block'>Iniciar Sesi&oacute;n</span><span className='md:hidden'>Login</span>
                        </Button>
                    </Link>
                  </div>
              </div>
              <div className='maincontainer p-2 md:p-0 pt-0'>
                <div className='text-standardGray font-bold flex md:hidden'>
                      <ul className='flex flex-row space-x-4 text-lg list-none m-0 pl-4'>
                          <li><a style={{ fontSize: 14 }} className='text-standardGray header-link' href="/">Home</a></li>
                          <li><a style={{ fontSize: 14 }} className='text-standardGray header-link' href="#services">Servicios</a></li>
                          {/* <li>Productos</li> */}
                          <li><a style={{ fontSize: 14 }} className='text-standardGray header-link' href="#contact">Contacto</a></li>
                      </ul>
                  </div>
              </div>
          </div>
        </>
    );
}

export default Header;